import { Button, Col, Container, Image, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
// swiper js
import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import "./MyProjects.css";
// import Swiper core and required modules
import SwiperCore, { EffectCoverflow, Pagination } from "swiper";
import DetailsModal from "../DetailsModal/DetailsModal";
// install Swiper modules
SwiperCore.use([EffectCoverflow, Pagination]);

const MyProjects = () => {
  const [projectData, setProjectData] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [show, setShow] = useState("");

  useEffect(() => {
    fetch("https://mocki.io/v1/b64d5c37-f019-4a5b-ad99-d8d0b59941a0")
      .then((res) => res.json())
      .then((data) => setProjectData(data));
  }, []);

  const handleModal = (el) => {
    console.log(el);
    setModalShow(true);
    setShow(el);
  };

  return (
    <Container className="my-projects-container" fluid>
      <div className="page-title mx-auto">
        <h1 className="myProject-title">
          My <span style={{ color: "#5c4ffd" }}>Projects</span>
        </h1>
      </div>
      <Row>
        <Col>
          <div id="my-projects" className="swiper-slider-container">
            <Swiper
              spaceBetween={0}
              effect={"coverflow"}
              grabCursor={true}
              centeredSlides={true}
              slidesPerView={"auto"}
              coverflowEffect={{
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true,
              }}
              pagination={true}
              className="mySwiper"
            >
              {projectData.map((el) => (
                <SwiperSlide className="project-show-card shadow-lg rounded-3">
                 
                  <div className="card project-card" style={{ width: "18rem" }}>
                    <img
                      src={el.url}
                      className="card-img-top project-img"
                      alt="project img"
                      fluid
                    />
                    <div className="card-body">
                      <h3
                        className="card-title"
                        style={{ color: " #064844", fontWeight: "bold" }}
                      >
                        {el.title}
                      </h3>
                      <p className="card-text">{el.details1}</p>
                      <div className="d-flex justify-content-start align-items-center flex-wrap">
                        {el.tools1 && (
                          <span className="project-tools">{el.tools1}</span>
                        )}
                        {el.tools2 && (
                          <span className="project-tools">{el.tools2}</span>
                        )}
                        {el.tools3 && (
                          <span className="project-tools">{el.tools3}</span>
                        )}
                        {el.tools4 && (
                          <span className="project-tools">{el.tools4}</span>
                        )}
                        {el.tools5 && (
                          <span className="project-tools">{el.tools5}</span>
                        )}
                        {el.tools6 && (
                          <span className="project-tools">{el.tools6}</span>
                        )}
                      </div>
                    </div>
                    <Button onClick={() => handleModal(el)}>Details</Button>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <DetailsModal
              show={modalShow}
              showValue={show}
              onHide={() => setModalShow(false)}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default MyProjects;
